namespace Areas.Account.ContractsSummary{
    "use strict";

    export function goToActions(sharePointLink: string, projectInfoId: number) {
        return (e: any) => {
            if (e.value == 1) {
                goToSharePoint(sharePointLink);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 3) {
                goToContract(e);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 4) {
                goToQuestionnaire(e);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 5) {
                goToPrimaryContractor(e);
                clearSelectBoxSelection(e);
                return;
            }
        }
    } 

    function goToSharePoint(sharePointLink) {
        let linkInfo = "https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjects/" + sharePointLink + "/";
        if (sharePointLink != "") {
            window.open(linkInfo);
        }
        else {
            window.open("https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjectsList");
        }
    }

    function goToPIFPAF(projectInfoId) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        if (projectInfoId != 0) {
            window.open(linkInfo);
        }

    }


    //TODO: Ask from where comes the property PrimaryContractorId

    function goToPrimaryContractor(e: any) {
        const grid = $("#ContractsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].vendorId;
            let linkInfo = "https://contract.capnet.ucla.edu/Vendor/Profile/View/" + id;
            window.open(linkInfo);
        }
    }

    function goToQuestionnaire(e: any) {
        const grid = $("#ContractsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].questionnaireId;
            let linkInfo = "https://contract.capnet.ucla.edu/Contract/GeneralInfo/View/" + id;
            window.open(linkInfo);
        }
    }

    function goToContract(e: any) {
        const grid = $("#ContractsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].contractId;
            let linkInfo = "https://contract.capnet.ucla.edu/Contract/GeneralInfo/View/" + id;
            window.open(linkInfo);
        }
    }

    export function columnViewLink(cellElement: any, cellInfo: any) {
        let linkInfo = "<a href= 'https://contract.capnet.ucla.edu/Contract/GeneralInfo/View/{placeholder}' target=\"_blank\">View</a>";

        buildCellContent(cellElement,
            () => { return cellInfo.data.contractId; },
            linkInfo);
    }


    

}